// material ui
import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';

const badgeContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'enableRipple',
})(({ theme, color = '#44b700', enableRipple = false }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: color,
    color: color,
    width: '15px',
    height: '15px',
    borderRadius: '50%',
    fontSize: '1rem',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
      ...(enableRipple && {
        animation: 'ripple 1.2s infinite ease-in-out',
      }),
    },
  },
  '@keyframes ripple': {
    '0%': { transform: 'scale(.8)', opacity: 1 },
    '100%': { transform: 'scale(2.4)', opacity: 0 },
  },
}));

const StyledBadgeWrapper = ({ color, enableRipple }) => (
  <div style={badgeContainerStyle}>
    <StyledBadge color={color} enableRipple={enableRipple} variant="dot" />
  </div>
);

export default StyledBadgeWrapper;
